import React from 'react';
import Card from '../components/ui/Card';
import Badge from '../components/ui/Badge';
import { useStudentPortal } from '../store/StudentPortalContext';

const supportLinks = [
  { label: 'NHS mental health support', url: 'https://www.nhs.uk/mental-health/' },
  { label: 'Mind charity', url: 'https://www.mind.org.uk/' },
  { label: 'YoungMinds', url: 'https://www.youngminds.org.uk/' },
  { label: 'Citizens Advice Bureau', url: 'https://www.citizensadvice.org.uk/' }
];

export default function StudentPortalSupportPage() {
  const { student } = useStudentPortal();
  const keyWorker = student?.keyWorker || null;
  const supportWorkers = student?.supportWorkers || [];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="sp-value" style={{ fontSize: '20px', fontWeight: 600 }}>Support & Wellbeing</h2>
        <p className="sp-muted">Helpful resources, support contacts, and wellbeing tools.</p>
      </div>

      <div className="grid lg:grid-cols-2 gap-4">
        <Card className="p-5 space-y-3">
          <h3 className="sp-value" style={{ fontWeight: 600 }}>Your support team</h3>
          {keyWorker ? (
            <div className="sp-panel sp-panel--muted p-3">
              <div className="sp-value" style={{ fontWeight: 600 }}>{keyWorker.name}</div>
              <div className="text-xs sp-muted">Key worker</div>
            </div>
          ) : (
            <p className="text-sm sp-muted">No key worker assigned yet.</p>
          )}
          {supportWorkers.length > 0 && (
            <div className="space-y-2">
              {supportWorkers.map((worker) => (
                <div key={worker.id || worker.name} className="sp-panel sp-panel--muted p-3">
                  <div className="sp-value" style={{ fontWeight: 600 }}>{worker.name}</div>
                  <div className="text-xs sp-muted">Support worker</div>
                </div>
              ))}
            </div>
          )}
        </Card>

        <Card className="p-5 space-y-3">
          <h3 className="sp-value" style={{ fontWeight: 600 }}>Wellbeing resources</h3>
          <p className="text-sm sp-muted">Reach out early. Support is available.</p>
          <div className="space-y-2 text-sm">
            {supportLinks.map((link) => (
              <a key={link.url} className="sp-link" href={link.url} target="_blank" rel="noreferrer">
                {link.label}
              </a>
            ))}
          </div>
          <div className="sp-panel sp-panel--muted p-3 text-sm">
            <div className="flex items-center justify-between">
              <span>Wellbeing check-in</span>
              <Badge variant="review">Weekly</Badge>
            </div>
            <div className="text-xs sp-muted mt-1">
              Keep a short note on how you are feeling, and share it with your support team if needed.
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
